module.exports = "<ng-template #navbarHeaderTextTemplate>\n    <ng-content></ng-content>\n</ng-template>"